import { Birthday } from "./Birthday";
import { OptionsRecentlyViewed } from "./OptionsRecentlyViewed";
import { QuickSearch } from "./QuickSearch";
import { RecentlyViewed } from "./RecentlyViewed";

export function HomePage()  {
  return (
    <>
        <div class="m-0 p-0 row align-items-top content">
            <div class="m-0 p-2 col-sm-12 col-md-4 text-center">
                <RecentlyViewed/>
            </div>
            <div class="m-0 p-2 col-sm-12 col-md-4 text-center">
                <QuickSearch/>
            </div>
            <div class="m-0 p-2 col-sm-12 col-md-4 text-center">
                <OptionsRecentlyViewed/>
            </div>
        </div>
        <div class="m-0 p-0 row align-items-top content">
            <div class="m-0 p-2 col-sm-12 col-md-4 text-center">
                <Birthday/>
            </div>
            <div class="m-0 p-2 col-sm-12 col-md-4 text-center">
            </div>
            <div class="m-0 p-2 col-sm-12 col-md-4 text-center">
            </div>
        </div>
    </>
  );
}
